import {MathUtils, Vector2} from 'three'

import type {MonaCanvasOpeningAnimation} from '../MonaCanvas'

const START_X = -1.25
const END_X = 1.25
const START_Y = -1.1
const END_Y = 2.4
const HORIZONTAL_SPEED = {
  // lerp
  START: 1,
  END: 0.2,
}

const LENGTH_X = END_X - START_X
const LENGTH_Y = END_Y - START_Y

const OFFSET_Y = 0.2
const FACING_ROTATION_SCALE = 0.65
const FACING_PITCH_OFFSET = 0.15

class MonaFooterOpeningAnimation implements MonaCanvasOpeningAnimation {
  readonly pointerPosition = new Vector2(START_X, START_Y)
  readonly facingRotationScale = FACING_ROTATION_SCALE
  readonly facingPitchOffset = FACING_PITCH_OFFSET
  readonly resetPoseOnComplete = true
  hasReachedEnd = false

  #time = 0

  update(delta: number) {
    if (this.hasReachedEnd) return

    let xProgress = (this.pointerPosition.x - START_X) / LENGTH_X
    xProgress *= xProgress

    const speed = MathUtils.lerp(HORIZONTAL_SPEED.START, HORIZONTAL_SPEED.END, xProgress)

    this.pointerPosition.x = Math.min(END_X, this.pointerPosition.x + delta * speed)
    this.#time += delta * speed

    const offsetY = Math.sin(this.#time * 5.0) * 1.7
    this.pointerPosition.y =
      OFFSET_Y + Math.min(END_Y, this.pointerPosition.x + delta * speed * (LENGTH_Y / LENGTH_X)) - offsetY
    this.hasReachedEnd = this.pointerPosition.x === END_X
  }
}

export function createMonaFooterOpeningAnimation(): MonaCanvasOpeningAnimation {
  return new MonaFooterOpeningAnimation()
}
